import React from "react";
import "./App.css";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Helmet } from "react-helmet-async";
import { WaveCanvas, SiteNav, SiteFooter } from "./Home";

const Photo1 = "/images/wajdi-aidan-coach-athlete-of-year-awards.png";
const Photo2 = "/images/wajdi-aidan-coach-athlete-of-year.png";

export default function NewsCoachOfYear() {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>Olympic Wave | Coach & Athlete of the Year 2025–2026</title>
        <meta
          name="description"
          content="Wajdi Bouallègue named Senior Coach of the Year and Aidan Li named Senior Athlete of the Year."
        />
        <meta property="og:type" content="article" />
        <meta
          property="og:url"
          content="https://olympicwave.ca/news/wajdi-bouallegue-coach-of-the-year-aidan-li-athlete-of-the-year-2026"
        />
      </Helmet>

      <WaveCanvas />
      <div className="ow-page">
        <SiteNav />

        <main className="ow-inner ow-article-inner">
          <div className="ow-article-body" style={{ marginTop: "0.5rem" }}>
            {/* Page header */}
            <div
              style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
            >
              <Link
                to="/news"
                className="ow-article-back-link"
                style={{ position: "static", alignSelf: "flex-start" }}
              >
                <ArrowLeft size={15} strokeWidth={2} /> {t("back")}
              </Link>
              <p className="ow-eyebrow">{t("coach_season_sub")}</p>
              <h1 className="ow-page-title">{t("coach_season_title")}</h1>
              <p className="ow-page-lead" style={{ color: "var(--muted)" }}>
                {t("coach_year_lead")}
              </p>
            </div>

            {/* Row 1 */}
            <div className="ow-article-row">
              <div className="ow-article-img-wrap ow-img-tall">
                <img src={Photo2} alt="Wajdi Bouallègue and Aidan Li" />
              </div>
              <div className="ow-article-text">
                <h2 className="ow-article-section-title">
                  {t("coach_year_title_1")}
                </h2>
                <p className="ow-article-p">{t("coach_year_text_1a")}</p>
                <p className="ow-article-p">{t("coach_year_text_1b")}</p>
              </div>
            </div>

            {/* Row 2 */}
            <div className="ow-article-row">
              <div className="ow-article-text">
                <h2 className="ow-article-section-title">
                  {t("coach_year_title_2")}
                </h2>
                <p className="ow-article-p">{t("coach_year_text_2a")}</p>
                <p className="ow-article-p">{t("coach_year_text_2b")}</p>
              </div>
              <div className="ow-article-img-wrap ow-img-tall">
                <img
                  src={Photo1}
                  alt="Wajdi Bouallègue and Aidan Li receiving Coach and Athlete of the Year awards"
                />
              </div>
            </div>

            {/* Row 3 — closing */}
            <div className="ow-article-row-full">
              <div className="ow-article-text ow-text-center">
                <h2 className="ow-article-section-title">
                  {t("coach_year_title_3")}
                </h2>
                <p className="ow-article-p">{t("coach_year_text_3a")}</p>
                <p className="ow-article-p">{t("coach_year_text_3b")}</p>
              </div>
            </div>
          </div>
        </main>

        <SiteFooter />
      </div>
    </>
  );
}
